import React from 'react';
import { Navbar, NavLeft, NavRight, Block, NavTitle } from 'framework7-react';
import { setLiteral } from '../../../js/helpers';

const NavbarComponent = ({ userData, lsLiterales }) => {
    return (
        <Navbar className='holis' sliding panelOpen="left">
            <NavLeft>
                <div ></div>
                <Block className='nameCli'>
                    {userData
                        // ? `HOLA ${userData.firstName} ${userData.lastName} ${userData.secondLastName}`
                        ? `${setLiteral(lsLiterales, 102135) + ', ' + userData.name}`
                        : 'Loading...'}
                </Block>
            </NavLeft>
            
        </Navbar>
    );
};

export default NavbarComponent;
